var map = {
	"./avatars/avatar_1.png": 3228,
	"./buttons/default_button/left.png": 33804,
	"./buttons/default_button/left_click.png": 77777,
	"./buttons/default_button/left_hv.png": 23919,
	"./buttons/default_button/mid.png": 91121,
	"./buttons/default_button/mid_click.png": 54540,
	"./buttons/default_button/mid_hv.png": 852,
	"./buttons/default_button/right.png": 64553,
	"./buttons/default_button/right_click.png": 52996,
	"./buttons/default_button/right_hv.png": 72156,
	"./buttons/deposit_btn.png": 25269,
	"./buttons/earning_btn.png": 15257,
	"./buttons/earning_rank_button/earning_rank.png": 84406,
	"./buttons/earning_rank_button/earning_rank_click.png": 98795,
	"./buttons/earning_rank_button/earning_rank_hv.png": 57917,
	"./buttons/home_btn.png": 76144,
	"./buttons/leader_rank_button/leader_rank.png": 38362,
	"./buttons/leader_rank_button/leader_rank_click.png": 50127,
	"./buttons/leader_rank_button/leader_rank_hv.png": 35625,
	"./buttons/next_page_button/next.png": 98532,
	"./buttons/next_page_button/next_click.png": 20617,
	"./buttons/next_page_button/next_hv.png": 39831,
	"./buttons/next_page_button/right_arrow.png": 87243,
	"./buttons/next_page_button/right_arrow_click.png": 18854,
	"./buttons/next_page_button/right_arrow_hv.png": 74210,
	"./buttons/pick_nugget.png": 51802,
	"./buttons/pop_close_button/x.png": 89998,
	"./buttons/pop_close_button/x_click.png": 55907,
	"./buttons/pop_close_button/x_hover.png": 76005,
	"./buttons/prev_page_button/left_arrow.png": 23250,
	"./buttons/prev_page_button/left_arrow_click.png": 88564,
	"./buttons/prev_page_button/left_arrow_hv.png": 95697,
	"./buttons/prev_page_button/prev.png": 81248,
	"./buttons/prev_page_button/prev_click.png": 2261,
	"./buttons/prev_page_button/prev_hv.png": 90075,
	"./buttons/ranking_btn.png": 31185,
	"./buttons/tab_button/left.png": 35810,
	"./buttons/tab_button/left_click.png": 49943,
	"./buttons/tab_button/left_click_mobile.png": 98570,
	"./buttons/tab_button/left_hv.png": 95393,
	"./buttons/tab_button/mid.png": 74615,
	"./buttons/tab_button/mid_click.png": 73202,
	"./buttons/tab_button/mid_hv.png": 28646,
	"./buttons/tab_button/mid_mobile.png": 99978,
	"./buttons/tab_button/right.png": 88511,
	"./buttons/tab_button/right_click.png": 89370,
	"./buttons/tab_button/right_click_mobile.png": 40873,
	"./buttons/tab_button/right_hv.png": 52798,
	"./buttons/template_adjustable_image_text/left.png": 42322,
	"./buttons/template_adjustable_image_text/left_click.png": 51335,
	"./buttons/template_adjustable_image_text/left_hv.png": 78033,
	"./buttons/template_adjustable_image_text/mid.png": 74471,
	"./buttons/template_adjustable_image_text/mid_click.png": 85826,
	"./buttons/template_adjustable_image_text/mid_hv.png": 93622,
	"./buttons/template_adjustable_image_text/right.png": 82959,
	"./buttons/template_adjustable_image_text/right_click.png": 11786,
	"./buttons/template_adjustable_image_text/right_hv.png": 73582,
	"./buttons/template_image/withdraw_button.png": 6968,
	"./buttons/template_image/withdraw_button_click.png": 85165,
	"./buttons/template_image/withdraw_button_hv.png": 20355,
	"./buttons/withdraw_btn.png": 42443,
	"./common/number_frame.png": 2203,
	"./nuggets/1.png": 18757,
	"./nuggets/2.png": 64750,
	"./nuggets/3.png": 93975,
	"./nuggets/4.png": 61336,
	"./nuggets/5.png": 82465,
	"./nuggets/6.png": 51882,
	"./nuggets/7.png": 7091,
	"./nuggets/8.png": 11796,
	"./popups/default/left.png": 6653,
	"./popups/default/left_input.png": 54916,
	"./popups/default/mid.png": 24446,
	"./popups/default/mid_input.png": 92111,
	"./popups/default/right.png": 93502,
	"./popups/default/right_input.png": 17775,
	"./popups/nugget_detail_frame.png": 33542,
	"./scene/gameplay/bottom_container/bottom_tab_bg.png": 1111,
	"./scene/gameplay/bottom_container/number_1.png": 3455,
	"./scene/gameplay/bottom_container/number_2.png": 18180,
	"./scene/gameplay/bottom_container/number_3.png": 81421,
	"./scene/gameplay/earning_rank/background.png": 59958,
	"./scene/gameplay/earning_rank/earning_board.png": 9959,
	"./scene/gameplay/floor_extend.png": 35135,
	"./scene/gameplay/leader_rank/rank_1.png": 67919,
	"./scene/gameplay/leader_rank/rank_2.png": 49012,
	"./scene/gameplay/leader_rank/rank_3.png": 70141,
	"./scene/gameplay/leader_rank/rank_frame.png": 74697,
	"./scene/gameplay/left_container/left_bottom.png": 54227,
	"./scene/gameplay/left_container/left_foreground.png": 21705,
	"./scene/gameplay/left_container/left_middle.png": 38669,
	"./scene/gameplay/left_container/left_top.png": 59977,
	"./scene/gameplay/loading_animation/bid_nugget.gif": 99521,
	"./scene/gameplay/loading_animation/explore_nugget.gif": 19781,
	"./scene/gameplay/loading_animation/list_nugget.gif": 89680,
	"./scene/gameplay/loading_animation/pick_nugget.gif": 89161,
	"./scene/gameplay/loading_animation/settle_nugget.gif": 59487,
	"./scene/gameplay/nugget/level.png": 21315,
	"./scene/gameplay/nugget/level_idle.png": 58650,
	"./scene/gameplay/nugget/nugget_bg.png": 28873,
	"./scene/gameplay/nugget/tag_frame.png": 67871,
	"./scene/gameplay/right_container/right_bottom.png": 93623,
	"./scene/gameplay/right_container/right_foreground.png": 3925,
	"./scene/gameplay/right_container/right_middle.png": 32737,
	"./scene/gameplay/right_container/right_top.png": 46045,
	"./scene/gameplay/top_container/available.png": 15605,
	"./scene/gameplay/top_container/cash.png": 2787,
	"./scene/gameplay/top_container/coin.png": 52297,
	"./scene/gameplay/top_container/deco_bar.png": 3443,
	"./scene/gameplay/top_container/number_frame.png": 58647,
	"./scene/gameplay/top_container/player_coin.png": 46365,
	"./scene/gameplay/top_container/player_id.png": 82085,
	"./scene/gameplay/top_container/top_bg.png": 23307,
	"./scene/gameplay/top_container/top_foreground.png": 63217,
	"./scene/gameplay/top_container/top_foreground_extend.png": 818,
	"./scene/gameplay/top_container/treasure.png": 57129,
	"./scene/loading_page/bar.png": 39629,
	"./scene/loading_page/connecting_bg.png": 49074,
	"./scene/loading_page/frame.png": 5345,
	"./scene/loading_page/loading_bg.png": 98714,
	"./scene/loading_page/progress_background/left.png": 9608,
	"./scene/loading_page/progress_background/mid.png": 29909,
	"./scene/loading_page/progress_background/right.png": 93405,
	"./scene/loading_page/progress_content/left.png": 71383,
	"./scene/loading_page/progress_content/mid.png": 74792,
	"./scene/loading_page/progress_content/right.png": 16264,
	"./scene/welcome_page/welcome_bg.png": 59198,
	"./scene/welcome_page/welcome_bg_mobile.png": 14461
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 191;